<template>
  <div id="app">
    <vue-confirm-dialog></vue-confirm-dialog>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  async mounted() {
    // Fetch settings from Firestore on app load
    await this.$store.dispatch('settings/fetchSettings')
  }
}
</script>

<style>
@import './assets/css/copy-button.css';
</style>